import React, { useState, useEffect, useContext } from "react";
import "./Agentusers.css";
import { NavLink } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import { motion } from "framer-motion";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import "./Chitgroup.css";
import moment from "moment";
import AgentSide from "../agentcompo/AgentSide";
import { AgentContext } from "../context/agentcontext";
import userimage from "./images/userimage.png"

const AgentAllusers = () => {
  const usernamedashboard = localStorage.getItem("username");
  const [data, setData] = useState([]);
  const { groupId } = useParams(); // Extract the groupId from the URL path
  const { agentname } = useContext(AgentContext);
  const [user, setuser] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `http://localhost:5001/api/groupsUsersByGroupId/${groupId}`
        ); // Use the groupId from the URL path
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [groupId]);

  useEffect(() => {
    const fetchnameData = async () => {
      try {
        const response = await axios.get(
          `http://localhost:5001/api/getmemberdetails/afterlogin/${usernamedashboard}`
        );
        setuser({ ...response.data[0] });
      } catch (error) {
        console.error("Error fetching assessment data", error);
      }
    };
    fetchnameData();
  }, [usernamedashboard]);

  return (
    <div style={{ display: "flex", overflow:"hidden" }}>
      <div>
        <AgentSide />
      </div>
      <div className="C-ttd">
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
          className="C-courses1"
        >
          <div className="A-alluserscss">
            <div className="courses1-head">
              <div className="info-h1">
                <div>
                  <NavLink
                    
                    to={"/agentchits"}
                  >
                    <FaArrowLeftLong className="Agent-Arrow" />
                  </NavLink>
                </div>
                
                <div className="dash-heading">
                  <h2>All users</h2>
                </div>
              </div>

              <div style={{ display: "flex", gap: "10px" ,marginRight:"30px" }}>
                <div className="image">
                  <img
                  src={user.uploadPhoto? `http://localhost:5001/uploads/${user.uploadPhoto}` : userimage}
                    // src={`http://localhost:5001/uploads/${user.uploadPhoto}`}
                    alt=""
                    style={{
                      height: "50px",
                      borderRadius: "30px",
                      width: "50px",
                    }}
                    className="images"
                  ></img>
                </div>
                <div>
                  <p style={{ margin: "0px" }}>{user.UserName}</p>
                  <p style={{ margin: "0px" }}>({user.role})</p>
                </div>
              </div>
            </div>

            <hr style={{ margin: "10px 0px" }}></hr>

            <div className="">
              <div className="U-table-auction">
                <table className="U-tables-style">
                  <thead>
                    <tr>
                      <th className="tahe" style={{ textAlign: "center", margin: "0px" }}>
                        No.
                      </th>
                      <th className="tahe" style={{ textAlign: "center" }}>Group ID</th>
                      <th className="tahe" style={{ textAlign: "center" }}>Group Name</th>
                      <th className="tahe" style={{ textAlign: "center" }}>User ID</th>
                      <th className="tahe" style={{ textAlign: "center" }}>User Name</th>
                      <th className="tahe" style={{ textAlign: "center" }}>mobileNo</th>
                      <th className="tahe" style={{ textAlign: "center" }}>Email</th>
                      <th className="tahe" style={{ textAlign: "center" }}>UserAdded Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data.length > 0 ? (
                      data.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.group_Id}</td>
                          <td>{item.group_Name}</td>
                          <td>{item.user_Id}</td>
                          <td>{item.user_Name}</td>
                          <td>{item.user_mobileNo}</td>
                          <td>{item.email}</td>
                          <td>
                            {moment(item.userAddedDate).format("DD-MM-YYYY")}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" style={{ textAlign: "center" }}>
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AgentAllusers;
